import { useState, useCallback, useEffect } from 'react';
import { EventData, EVENTS, STATUS, Step } from 'react-joyride';

const TOUR_KEY = 'solimat-delta-tour-v1';

export const useDeltaTour = () => {
  const [run, setRun] = useState(false);
  const [tourKey, setTourKey] = useState(0);

  const steps: Step[] = [
      // ── Visión general ────────────────────────────────────────────────
    {
      target: '.delta-groups',
      title: 'Gestión de accidentes DELT@',
      content: 'Aquí encontrarás los expedientes de accidentes laborales organizados en dos grupos: con baja médica y sin baja médica. Cada grupo muestra el estado de comunicación con el sistema DELT@.',
      placement: 'top',
      skipBeacon: true,
    },
    // ── Grupo Con Baja ────────────────────────────────────────────────
    {
      target: '.delta-groups > section:first-child',
      title: 'Accidentes con baja médica',
      content: 'Este grupo recoge los partes de accidente que han generado una baja médica. Están divididos según su estado de comunicación con el sistema DELT@.',
      placement: 'top',
      skipBeacon: true,
    },
    {
      target: '.delta-groups > section:first-child .delta-card:first-child',
      title: 'Con baja — Pendientes DELT@',
      content: 'Partes de accidente con baja médica que aún no han sido comunicados al sistema DELT@. Requieren tu atención para completar la tramitación.',
      placement: 'right',
      skipBeacon: true,
    },
    {
      target: '.delta-groups > section:first-child .delta-card:last-child',
      title: 'Con baja — DELT@ remesados',
      content: 'Partes con baja médica que ya han sido remesados al sistema DELT@.',
      placement: 'right',
      skipBeacon: true,
    },
    // ── Grupo Sin Baja ────────────────────────────────────────────────
    {
      target: '.delta-groups > section:last-child',
      title: 'Accidentes sin baja médica',
      content: 'Este grupo recoge los partes de accidente que no generaron baja médica, también organizados según su estado en el sistema DELT@.',
      placement: 'top',
      skipBeacon: true,
    },
    {
      target: '.delta-groups > section:last-child .delta-card:first-child',
      title: 'Sin baja — Pendientes DELT@',
      content: 'Partes de accidente sin baja médica pendientes de comunicar al sistema DELT@.',
      placement: 'right',
      skipBeacon: true,
    },
    {
      target: '.delta-groups > section:last-child .delta-card:last-child',
      title: 'Sin baja — DELT@ remesados',
      content: 'Partes sin baja médica ya enviados y procesados en el sistema DELT@.',
      placement: 'right',
      skipBeacon: true,
    },
  ];

  const handleCallback = useCallback((data: EventData) => {
    const { type, status, index } = data as any;
    const finished = status === STATUS.FINISHED || status === STATUS.SKIPPED;

    if (finished || (type as string) === EVENTS.TOUR_END) {
      setRun(false);
      localStorage.setItem(TOUR_KEY, 'true');
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }

    if ((type as string) === EVENTS.STEP_AFTER && index === 0) {
      window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: false } }));
    }
  }, []);

  const startTour = useCallback(() => {
    setRun(current => {
      if (current) return false;
      setTourKey(k => k + 1);
      return true;
    });
  }, []);

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('solimat:tourStateChange', { detail: { active: run } }));
  }, [run]);

  return { run, tourKey, steps, handleCallback, startTour };
};
